import { EntityTaggingProvider } from './EntityTaggingProvider'
import { orderTaggingAdapter } from './orderTaggingAdapter'
import type { TaggingProviderProps } from './TaggingProvider.types'

export const OrderTaggingProvider = (props: TaggingProviderProps) => (
  <EntityTaggingProvider {...props} adapter={orderTaggingAdapter} />
)
